import { render } from "./App.vue?vue&type=template&id=5592a8c3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5592a8c3&lang=css"

import exportComponent from "/home/n3rdy/dev/virtuallab-networksecurity/exp-6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__